import { transformTSIntoNaturalDate } from 'plugin-codaf-risk-ext-bowtie/utils'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from 'plugin-codaf-risk-ext-bowtie/utils/constants'

export interface IDraExportFilters {
    entityType: string
    id: number
}

export const DraExportSingleData = async (params?: IDraExportFilters): Promise<void> => {
    const { id } = params
    const qs = new URLSearchParams({
        entityType: params?.entityType?.toString()
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.export}/SINGLEBOWTIE/${id}?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(async response => {
            if (response.ok) {
                return response.blob()
            } else {
                let jsonData
                try {
                    jsonData = await response.json()
                } catch (err) {
                    jsonData = undefined
                }
                throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
            }
        })
        .then(blob => {
            try {
                const time = new Date()
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute(
                    'download',
                    `${params.entityType} export ${transformTSIntoNaturalDate(time.getTime())}.csv`
                )
                a.click()
                URL.revokeObjectURL(url)
            } catch (error) {
                console.log(error)
            }
        })
}
